(function () {
    "use strict";

    var API_BASE = "https://mystery-cube.vercel.app";
    var TIMEOUT_MS = 15000;

    // UK first, then all countries A-Z
    var COUNTRIES = [
        { flag: "🇬🇧", code: "+44",   name: "United Kingdom" },
        { flag: "🇦🇫", code: "+93",   name: "Afghanistan" },
        { flag: "🇦🇱", code: "+355",  name: "Albania" },
        { flag: "🇩🇿", code: "+213",  name: "Algeria" },
        { flag: "🇦🇸", code: "+1684", name: "American Samoa" },
        { flag: "🇦🇩", code: "+376",  name: "Andorra" },
        { flag: "🇦🇴", code: "+244",  name: "Angola" },
        { flag: "🇦🇮", code: "+1264", name: "Anguilla" },
        { flag: "🇦🇶", code: "+672",  name: "Antarctica" },
        { flag: "🇦🇬", code: "+1268", name: "Antigua and Barbuda" },
        { flag: "🇦🇷", code: "+54",   name: "Argentina" },
        { flag: "🇦🇲", code: "+374",  name: "Armenia" },
        { flag: "🇦🇼", code: "+297",  name: "Aruba" },
        { flag: "🇦🇺", code: "+61",   name: "Australia" },
        { flag: "🇦🇹", code: "+43",   name: "Austria" },
        { flag: "🇦🇿", code: "+994",  name: "Azerbaijan" },
        { flag: "🇧🇸", code: "+1242", name: "Bahamas" },
        { flag: "🇧🇭", code: "+973",  name: "Bahrain" },
        { flag: "🇧🇩", code: "+880",  name: "Bangladesh" },
        { flag: "🇧🇧", code: "+1246", name: "Barbados" },
        { flag: "🇧🇾", code: "+375",  name: "Belarus" },
        { flag: "🇧🇪", code: "+32",   name: "Belgium" },
        { flag: "🇧🇿", code: "+501",  name: "Belize" },
        { flag: "🇧🇯", code: "+229",  name: "Benin" },
        { flag: "🇧🇲", code: "+1441", name: "Bermuda" },
        { flag: "🇧🇹", code: "+975",  name: "Bhutan" },
        { flag: "🇧🇴", code: "+591",  name: "Bolivia" },
        { flag: "🇧🇦", code: "+387",  name: "Bosnia and Herzegovina" },
        { flag: "🇧🇼", code: "+267",  name: "Botswana" },
        { flag: "🇧🇻", code: "+47",   name: "Bouvet Island" },
        { flag: "🇧🇷", code: "+55",   name: "Brazil" },
        { flag: "🇮🇴", code: "+246",  name: "British Indian Ocean Territory" },
        { flag: "🇻🇬", code: "+1284", name: "British Virgin Islands" },
        { flag: "🇧🇳", code: "+673",  name: "Brunei" },
        { flag: "🇧🇬", code: "+359",  name: "Bulgaria" },
        { flag: "🇧🇫", code: "+226",  name: "Burkina Faso" },
        { flag: "🇧🇮", code: "+257",  name: "Burundi" },
        { flag: "🇰🇭", code: "+855",  name: "Cambodia" },
        { flag: "🇨🇲", code: "+237",  name: "Cameroon" },
        { flag: "🇨🇦", code: "+1",    name: "Canada" },
        { flag: "🇮🇨", code: "+34",   name: "Canary Islands" },
        { flag: "🇨🇻", code: "+238",  name: "Cape Verde" },
        { flag: "🇧🇶", code: "+599",  name: "Caribbean Netherlands" },
        { flag: "🇰🇾", code: "+1345", name: "Cayman Islands" },
        { flag: "🇨🇫", code: "+236",  name: "Central African Republic" },
        { flag: "🇹🇩", code: "+235",  name: "Chad" },
        { flag: "🇨🇱", code: "+56",   name: "Chile" },
        { flag: "🇨🇳", code: "+86",   name: "China" },
        { flag: "🇨🇽", code: "+61",   name: "Christmas Island" },
        { flag: "🇨🇨", code: "+61",   name: "Cocos (Keeling) Islands" },
        { flag: "🇨🇴", code: "+57",   name: "Colombia" },
        { flag: "🇰🇲", code: "+269",  name: "Comoros" },
        { flag: "🇨🇬", code: "+242",  name: "Congo" },
        { flag: "🇨🇰", code: "+682",  name: "Cook Islands" },
        { flag: "🇨🇷", code: "+506",  name: "Costa Rica" },
        { flag: "🇨🇮", code: "+225",  name: "Cote d'Ivoire" },
        { flag: "🇭🇷", code: "+385",  name: "Croatia" },
        { flag: "🇨🇺", code: "+53",   name: "Cuba" },
        { flag: "🇨🇼", code: "+599",  name: "Curaçao" },
        { flag: "🇨🇾", code: "+357",  name: "Cyprus" },
        { flag: "🇨🇿", code: "+420",  name: "Czech Republic" },
        { flag: "🇨🇩", code: "+243",  name: "Democratic Republic of the Congo" },
        { flag: "🇩🇰", code: "+45",   name: "Denmark" },
        { flag: "🇩🇯", code: "+253",  name: "Djibouti" },
        { flag: "🇩🇲", code: "+1767", name: "Dominica" },
        { flag: "🇩🇴", code: "+1809", name: "Dominican Republic" },
        { flag: "🇹🇱", code: "+670",  name: "East Timor" },
        { flag: "🇪🇨", code: "+593",  name: "Ecuador" },
        { flag: "🇪🇬", code: "+20",   name: "Egypt" },
        { flag: "🇸🇻", code: "+503",  name: "El Salvador" },
        { flag: "🇬🇶", code: "+240",  name: "Equatorial Guinea" },
        { flag: "🇪🇷", code: "+291",  name: "Eritrea" },
        { flag: "🇪🇪", code: "+372",  name: "Estonia" },
        { flag: "🇪🇹", code: "+251",  name: "Ethiopia" },
        { flag: "🇫🇰", code: "+500",  name: "Falkland Islands" },
        { flag: "🇫🇴", code: "+298",  name: "Faroe Islands" },
        { flag: "🇫🇯", code: "+679",  name: "Fiji" },
        { flag: "🇫🇮", code: "+358",  name: "Finland" },
        { flag: "🇫🇷", code: "+33",   name: "France" },
        { flag: "🇬🇫", code: "+594",  name: "French Guiana" },
        { flag: "🇵🇫", code: "+689",  name: "French Polynesia" },
        { flag: "🇹🇫", code: "+262",  name: "French Southern and Antarctic Lands" },
        { flag: "🇬🇦", code: "+241",  name: "Gabon" },
        { flag: "🇬🇲", code: "+220",  name: "Gambia" },
        { flag: "🇬🇪", code: "+995",  name: "Georgia" },
        { flag: "🇩🇪", code: "+49",   name: "Germany" },
        { flag: "🇬🇭", code: "+233",  name: "Ghana" },
        { flag: "🇬🇮", code: "+350",  name: "Gibraltar" },
        { flag: "🇬🇷", code: "+30",   name: "Greece" },
        { flag: "🇬🇱", code: "+299",  name: "Greenland" },
        { flag: "🇬🇩", code: "+1473", name: "Grenada" },
        { flag: "🇬🇵", code: "+590",  name: "Guadeloupe" },
        { flag: "🇬🇺", code: "+1671", name: "Guam" },
        { flag: "🇬🇹", code: "+502",  name: "Guatemala" },
        { flag: "🇬🇬", code: "+44",   name: "Guernsey" },
        { flag: "🇬🇳", code: "+224",  name: "Guinea" },
        { flag: "🇬🇼", code: "+245",  name: "Guinea-Bissau" },
        { flag: "🇬🇾", code: "+592",  name: "Guyana" },
        { flag: "🇭🇹", code: "+509",  name: "Haiti" },
        { flag: "🇭🇲", code: "+672",  name: "Heard Island and McDonald Islands" },
        { flag: "🇭🇳", code: "+504",  name: "Honduras" },
        { flag: "🇭🇰", code: "+852",  name: "Hong Kong" },
        { flag: "🇭🇺", code: "+36",   name: "Hungary" },
        { flag: "🇮🇸", code: "+354",  name: "Iceland" },
        { flag: "🇮🇳", code: "+91",   name: "India" },
        { flag: "🇮🇩", code: "+62",   name: "Indonesia" },
        { flag: "🇮🇷", code: "+98",   name: "Iran" },
        { flag: "🇮🇶", code: "+964",  name: "Iraq" },
        { flag: "🇮🇪", code: "+353",  name: "Ireland" },
        { flag: "🇮🇲", code: "+44",   name: "Isle of Man" },
        { flag: "🇮🇱", code: "+972",  name: "Israel" },
        { flag: "🇮🇹", code: "+39",   name: "Italy" },
        { flag: "🇯🇲", code: "+1876", name: "Jamaica" },
        { flag: "🇯🇵", code: "+81",   name: "Japan" },
        { flag: "🇯🇪", code: "+44",   name: "Jersey" },
        { flag: "🇯🇴", code: "+962",  name: "Jordan" },
        { flag: "🇰🇿", code: "+7",    name: "Kazakhstan" },
        { flag: "🇰🇪", code: "+254",  name: "Kenya" },
        { flag: "🇰🇮", code: "+686",  name: "Kiribati" },
        { flag: "🇽🇰", code: "+383",  name: "Kosovo" },
        { flag: "🇰🇼", code: "+965",  name: "Kuwait" },
        { flag: "🇰🇬", code: "+996",  name: "Kyrgyzstan" },
        { flag: "🇱🇦", code: "+856",  name: "Laos" },
        { flag: "🇱🇻", code: "+371",  name: "Latvia" },
        { flag: "🇱🇧", code: "+961",  name: "Lebanon" },
        { flag: "🇱🇸", code: "+266",  name: "Lesotho" },
        { flag: "🇱🇷", code: "+231",  name: "Liberia" },
        { flag: "🇱🇾", code: "+218",  name: "Libya" },
        { flag: "🇱🇮", code: "+423",  name: "Liechtenstein" },
        { flag: "🇱🇹", code: "+370",  name: "Lithuania" },
        { flag: "🇱🇺", code: "+352",  name: "Luxembourg" },
        { flag: "🇲🇴", code: "+853",  name: "Macau" },
        { flag: "🇲🇰", code: "+389",  name: "Macedonia (FYROM)" },
        { flag: "🇲🇬", code: "+261",  name: "Madagascar" },
        { flag: "🇲🇼", code: "+265",  name: "Malawi" },
        { flag: "🇲🇾", code: "+60",   name: "Malaysia" },
        { flag: "🇲🇻", code: "+960",  name: "Maldives" },
        { flag: "🇲🇱", code: "+223",  name: "Mali" },
        { flag: "🇲🇹", code: "+356",  name: "Malta" },
        { flag: "🇲🇭", code: "+692",  name: "Marshall Islands" },
        { flag: "🇲🇶", code: "+596",  name: "Martinique" },
        { flag: "🇲🇷", code: "+222",  name: "Mauritania" },
        { flag: "🇲🇺", code: "+230",  name: "Mauritius" },
        { flag: "🇾🇹", code: "+262",  name: "Mayotte" },
        { flag: "🇲🇽", code: "+52",   name: "Mexico" },
        { flag: "🇫🇲", code: "+691",  name: "Micronesia" },
        { flag: "🇲🇩", code: "+373",  name: "Moldova" },
        { flag: "🇲🇨", code: "+377",  name: "Monaco" },
        { flag: "🇲🇳", code: "+976",  name: "Mongolia" },
        { flag: "🇲🇪", code: "+382",  name: "Montenegro" },
        { flag: "🇲🇸", code: "+1664", name: "Montserrat" },
        { flag: "🇲🇦", code: "+212",  name: "Morocco" },
        { flag: "🇲🇿", code: "+258",  name: "Mozambique" },
        { flag: "🇲🇲", code: "+95",   name: "Myanmar (Burma)" },
        { flag: "🇳🇦", code: "+264",  name: "Namibia" },
        { flag: "🇳🇷", code: "+674",  name: "Nauru" },
        { flag: "🇳🇵", code: "+977",  name: "Nepal" },
        { flag: "🇳🇱", code: "+31",   name: "Netherlands" },
        { flag: "🇧🇶", code: "+599",  name: "Netherlands Antilles" },
        { flag: "🇳🇨", code: "+687",  name: "New Caledonia" },
        { flag: "🇳🇿", code: "+64",   name: "New Zealand" },
        { flag: "🇳🇮", code: "+505",  name: "Nicaragua" },
        { flag: "🇳🇪", code: "+227",  name: "Niger" },
        { flag: "🇳🇬", code: "+234",  name: "Nigeria" },
        { flag: "🇳🇺", code: "+683",  name: "Niue" },
        { flag: "🇳🇫", code: "+672",  name: "Norfolk Island" },
        { flag: "🇰🇵", code: "+850",  name: "North Korea" },
        { flag: "🇲🇵", code: "+1670", name: "Northern Mariana Islands" },
        { flag: "🇳🇴", code: "+47",   name: "Norway" },
        { flag: "🇴🇲", code: "+968",  name: "Oman" },
        { flag: "🇵🇰", code: "+92",   name: "Pakistan" },
        { flag: "🇵🇼", code: "+680",  name: "Palau" },
        { flag: "🇵🇸", code: "+970",  name: "Palestine" },
        { flag: "🇵🇦", code: "+507",  name: "Panama" },
        { flag: "🇵🇬", code: "+675",  name: "Papua New Guinea" },
        { flag: "🇵🇾", code: "+595",  name: "Paraguay" },
        { flag: "🇵🇪", code: "+51",   name: "Peru" },
        { flag: "🇵🇭", code: "+63",   name: "Philippines" },
        { flag: "🇵🇳", code: "+64",   name: "Pitcairn Islands" },
        { flag: "🇵🇱", code: "+48",   name: "Poland" },
        { flag: "🇵🇹", code: "+351",  name: "Portugal" },
        { flag: "🇵🇷", code: "+1787", name: "Puerto Rico" },
        { flag: "🇶🇦", code: "+974",  name: "Qatar" },
        { flag: "🇷🇴", code: "+40",   name: "Romania" },
        { flag: "🇷🇺", code: "+7",    name: "Russia" },
        { flag: "🇷🇼", code: "+250",  name: "Rwanda" },
        { flag: "🇷🇪", code: "+262",  name: "Réunion" },
        { flag: "🇧🇱", code: "+590",  name: "Saint Barthélemy" },
        { flag: "🇸🇭", code: "+290",  name: "Saint Helena" },
        { flag: "🇰🇳", code: "+1869", name: "Saint Kitts and Nevis" },
        { flag: "🇱🇨", code: "+1758", name: "Saint Lucia" },
        { flag: "🇲🇫", code: "+590",  name: "Saint Martin" },
        { flag: "🇵🇲", code: "+508",  name: "Saint Pierre and Miquelon" },
        { flag: "🇻🇨", code: "+1784", name: "Saint Vincent and the Grenadines" },
        { flag: "🇼🇸", code: "+685",  name: "Samoa" },
        { flag: "🇸🇲", code: "+378",  name: "San Marino" },
        { flag: "🇸🇹", code: "+239",  name: "Sao Tome and Principe" },
        { flag: "🇸🇦", code: "+966",  name: "Saudi Arabia" },
        { flag: "🇸🇳", code: "+221",  name: "Senegal" },
        { flag: "🇷🇸", code: "+381",  name: "Serbia" },
        { flag: "🇸🇨", code: "+248",  name: "Seychelles" },
        { flag: "🇸🇱", code: "+232",  name: "Sierra Leone" },
        { flag: "🇸🇬", code: "+65",   name: "Singapore" },
        { flag: "🇸🇰", code: "+421",  name: "Slovakia" },
        { flag: "🇸🇮", code: "+386",  name: "Slovenia" },
        { flag: "🇸🇧", code: "+677",  name: "Solomon Islands" },
        { flag: "🇸🇴", code: "+252",  name: "Somalia" },
        { flag: "🇿🇦", code: "+27",   name: "South Africa" },
        { flag: "🇬🇸", code: "+500",  name: "South Georgia and the South Sandwich Islands" },
        { flag: "🇰🇷", code: "+82",   name: "South Korea" },
        { flag: "🇸🇸", code: "+211",  name: "South Sudan" },
        { flag: "🇪🇸", code: "+34",   name: "Spain" },
        { flag: "🇱🇰", code: "+94",   name: "Sri Lanka" },
        { flag: "🇸🇩", code: "+249",  name: "Sudan" },
        { flag: "🇸🇷", code: "+597",  name: "Suriname" },
        { flag: "🇸🇯", code: "+47",   name: "Svalbard and Jan Mayen" },
        { flag: "🇸🇿", code: "+268",  name: "Swaziland" },
        { flag: "🇸🇪", code: "+46",   name: "Sweden" },
        { flag: "🇨🇭", code: "+41",   name: "Switzerland" },
        { flag: "🇸🇾", code: "+963",  name: "Syria" },
        { flag: "🇹🇼", code: "+886",  name: "Taiwan" },
        { flag: "🇹🇯", code: "+992",  name: "Tajikistan" },
        { flag: "🇹🇿", code: "+255",  name: "Tanzania" },
        { flag: "🇹🇭", code: "+66",   name: "Thailand" },
        { flag: "🇹🇬", code: "+228",  name: "Togo" },
        { flag: "🇹🇰", code: "+690",  name: "Tokelau" },
        { flag: "🇹🇴", code: "+676",  name: "Tonga" },
        { flag: "🇹🇹", code: "+1868", name: "Trinidad and Tobago" },
        { flag: "🇹🇳", code: "+216",  name: "Tunisia" },
        { flag: "🇹🇲", code: "+993",  name: "Turkmenistan" },
        { flag: "🇹🇨", code: "+1649", name: "Turks and Caicos Islands" },
        { flag: "🇹🇻", code: "+688",  name: "Tuvalu" },
        { flag: "🇹🇷", code: "+90",   name: "Türkiye" },
        { flag: "🇻🇮", code: "+1340", name: "U.S. Virgin Islands" },
        { flag: "🇺🇬", code: "+256",  name: "Uganda" },
        { flag: "🇺🇦", code: "+380",  name: "Ukraine" },
        { flag: "🇦🇪", code: "+971",  name: "United Arab Emirates" },
        { flag: "🇺🇸", code: "+1",    name: "United States" },
        { flag: "🇺🇲", code: "+1",    name: "United States Minor Outlying Islands" },
        { flag: "🇺🇾", code: "+598",  name: "Uruguay" },
        { flag: "🇺🇿", code: "+998",  name: "Uzbekistan" },
        { flag: "🇻🇺", code: "+678",  name: "Vanuatu" },
        { flag: "🇻🇦", code: "+39",   name: "Vatican City" },
        { flag: "🇻🇪", code: "+58",   name: "Venezuela" },
        { flag: "🇻🇳", code: "+84",   name: "Vietnam" },
        { flag: "🇼🇫", code: "+681",  name: "Wallis and Futuna" },
        { flag: "🇪🇭", code: "+212",  name: "Western Sahara" },
        { flag: "🇾🇪", code: "+967",  name: "Yemen" },
        { flag: "🇿🇲", code: "+260",  name: "Zambia" },
        { flag: "🇿🇼", code: "+263",  name: "Zimbabwe" },
        { flag: "🇦🇽", code: "+358",  name: "Åland Islands" },
    ];

    document.body.classList.add("mystery-page");

    function fetchWithTimeout(url, options) {
        var controller = new AbortController();
        var timer = setTimeout(function () {
            controller.abort();
        }, TIMEOUT_MS);
        return fetch(
            url,
            Object.assign({}, options || {}, { signal: controller.signal })
        ).then(
            function (res) {
                clearTimeout(timer);
                return res;
            },
            function (err) {
                clearTimeout(timer);
                throw err;
            }
        );
    }

    function init() {
        var code = new URLSearchParams(window.location.search).get("code");

        var stateLoading  = document.getElementById("mystery-loading");
        var stateInvalid  = document.getElementById("mystery-invalid");
        var stateRedeemed = document.getElementById("mystery-redeemed");
        var stateForm     = document.getElementById("mystery-form");
        var stateWinner   = document.getElementById("mystery-winner");
        var stateLoser    = document.getElementById("mystery-loser");
        var submitBtn     = document.getElementById("mystery-submit-btn");
        var form          = document.getElementById("mystery-form-el");

        var allStates = [
            stateLoading,
            stateInvalid,
            stateRedeemed,
            stateForm,
            stateWinner,
            stateLoser,
        ];

        // Populate country code select dynamically
        var countrySelect = document.getElementById("mystery-phone-country");
        if (countrySelect) {
            countrySelect.innerHTML = "";
            countrySelect.style.minWidth = "150px";
            COUNTRIES.forEach(function (c) {
                var opt = document.createElement("option");
                opt.value = c.code;
                opt.textContent = c.flag + " " + c.name;
                countrySelect.appendChild(opt);
            });
            countrySelect.value = "+44"; // UK default
        }

        function showState(el) {
            allStates.forEach(function (s) {
                if (s) s.classList.remove("active");
            });
            if (el) el.classList.add("active");
        }

        // Shows a retry button in the loading state instead of showing "Invalid Code"
        // on network failures — retailers on bad mobile signal shouldn't be told their
        // code is invalid when it's just a connectivity problem.
        function showNetworkError(retryFn) {
            showState(stateLoading);
            var spinner =
                stateLoading && stateLoading.querySelector(".mystery__spinner");
            var spinnerText =
                stateLoading &&
                stateLoading.querySelector(".mystery__spinner-text");
            if (spinner) spinner.style.display = "none";
            if (spinnerText)
                spinnerText.textContent =
                    "Connection error. Please check your signal.";

            var existing =
                stateLoading &&
                stateLoading.querySelector(".mystery__retry-btn");
            if (existing) existing.remove();

            var btn = document.createElement("button");
            btn.className = "mystery__retry-btn";
            btn.textContent = "Try Again";
            btn.style.cssText =
                "margin-top:16px;padding:10px 24px;background:#179ac7;color:#fff;border:none;border-radius:8px;font-size:14px;font-weight:600;cursor:pointer;";
            btn.onclick = function () {
                if (spinner) {
                    spinner.style.display = "";
                }
                if (spinnerText) {
                    spinnerText.textContent = "Validating your code...";
                }
                btn.remove();
                retryFn();
            };
            if (stateLoading) stateLoading.appendChild(btn);
        }

        function clearErrors() {
            if (!stateForm) return;
            stateForm.querySelectorAll("input").forEach(function (input) {
                input.classList.remove("error");
                var err = input.parentNode.querySelector(".mystery__error-text");
                if (err) err.remove();
            });
            var banner = stateForm.querySelector(".mystery__submit-error");
            if (banner) banner.remove();
        }

        function showFieldError(input, message) {
            input.classList.add("error");
            var err = document.createElement("p");
            err.className = "mystery__error-text";
            err.textContent = message;
            input.parentNode.appendChild(err);
        }

        // Inline error below the submit button — no alert() on mobile
        function showSubmitError(message) {
            var existing =
                stateForm && stateForm.querySelector(".mystery__submit-error");
            if (existing) existing.remove();
            var banner = document.createElement("p");
            banner.className = "mystery__submit-error";
            banner.textContent = message;
            banner.style.cssText =
                "color:#dc2626;font-size:14px;text-align:center;margin:8px 0 0;";
            if (submitBtn)
                submitBtn.parentNode.insertBefore(
                    banner,
                    submitBtn.nextSibling
                );
        }

        function setFormDisabled(disabled) {
            if (!form) return;
            form.classList[disabled ? "add" : "remove"]("is-submitting");
        }

        function validateCode() {
            fetchWithTimeout(
                API_BASE + "/api/validate?code=" + encodeURIComponent(code)
            )
                .then(function (res) {
                    if (!res.ok) throw new Error("server_error");
                    return res.json();
                })
                .then(function (data) {
                    if (data.status === "valid") showState(stateForm);
                    else if (data.status === "redeemed")
                        showState(stateRedeemed);
                    else showState(stateInvalid);
                })
                .catch(function () {
                    showNetworkError(validateCode);
                });
        }

        function handleSubmit(e) {
            e.preventDefault();
            clearErrors();

            var shopName = document
                .getElementById("mystery-shop-name")
                .value.trim();
            var ownerName = document
                .getElementById("mystery-owner-name")
                .value.trim();
            var email        = document.getElementById("mystery-email").value.trim();
            var phoneCountry = document.getElementById("mystery-phone-country").value;
            var phoneNumber  = document.getElementById("mystery-phone").value.trim();
            var phone        = phoneCountry + " " + phoneNumber;

            var valid = true;
            if (!shopName) {
                showFieldError(
                    document.getElementById("mystery-shop-name"),
                    "Shop name is required"
                );
                valid = false;
            }
            if (!ownerName) {
                showFieldError(
                    document.getElementById("mystery-owner-name"),
                    "Shop owner name is required"
                );
                valid = false;
            }
            if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
                showFieldError(
                    document.getElementById("mystery-email"),
                    "Valid email is required"
                );
                valid = false;
            }
            if (!phoneNumber || phoneNumber.replace(/[\s\-\(\)]/g, "").length < 6) {
                showFieldError(
                    document.getElementById("mystery-phone"),
                    "Valid phone number is required"
                );
                valid = false;
            }
            if (!valid) return;

            submitBtn.disabled = true;
            submitBtn.textContent = "Submitting...";
            setFormDisabled(true);

            fetchWithTimeout(API_BASE + "/api/submit", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    code: code,
                    shopName: shopName,
                    shopLocation: ownerName,
                    phone: phone,
                    email: email,
                }),
            })
                .then(function (res) { return res.json(); })
                .then(function (data) {
                    if (data.error) {
                        // "Already used" might mean the request went through but the response was
                        // lost (network dropped after server saved the entry). Re-validate to find
                        // out — if the code is now redeemed, the entry is safe and we tell them so.
                        if (data.error === "This code has already been used") {
                            submitBtn.textContent = "Checking...";
                            return fetchWithTimeout(
                                API_BASE +
                                    "/api/validate?code=" +
                                    encodeURIComponent(code)
                            )
                                .then(function (r) { return r.json(); })
                                .then(function (v) {
                                    if (v.status === "redeemed") {
                                        showSubmitError(
                                            "Your entry was already recorded. Check your email if you won!"
                                        );
                                        submitBtn.disabled = true;
                                        submitBtn.textContent = "Submitted";
                                    } else {
                                        setFormDisabled(false);
                                        submitBtn.disabled = false;
                                        submitBtn.textContent = "Submit";
                                        showSubmitError(data.error);
                                    }
                                })
                                .catch(function () {
                                    setFormDisabled(false);
                                    submitBtn.disabled = false;
                                    submitBtn.textContent = "Submit";
                                    showSubmitError(
                                        "Network error. Please check your connection and try again."
                                    );
                                });
                        }

                        setFormDisabled(false);
                        submitBtn.disabled = false;
                        submitBtn.textContent = "Submit";
                        showSubmitError(data.error);
                        return;
                    }

                    if (data.isWinner) {
                        var prizeNameEl = document.getElementById("mystery-prize-name");
                        var prizeDescEl = document.getElementById("mystery-prize-desc");
                        var discountEl  = document.getElementById("mystery-discount-code");
                        if (prizeNameEl) prizeNameEl.textContent = data.prizeName || "You Won!";
                        if (prizeDescEl) prizeDescEl.textContent = data.prizeDescription || "";
                        if (discountEl && data.discountCode) discountEl.textContent = data.discountCode;
                        showState(stateWinner);
                    } else {
                        showState(stateLoser);
                    }
                })
                .catch(function (err) {
                    setFormDisabled(false);
                    submitBtn.disabled = false;
                    submitBtn.textContent = "Submit";
                    showSubmitError(
                        err && err.name === "AbortError"
                            ? "Request timed out. Check your connection and try again."
                            : "Network error. Check your connection and try again."
                    );
                });
        }

        if (form) form.addEventListener("submit", handleSubmit);

        if (!code) {
            showState(stateInvalid);
            return;
        }

        showState(stateLoading);
        validateCode();
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", init);
    } else {
        init();
    }
})();
